import { useSyncExternalStore } from "react";

// His ONE 1-second tick (index.html:948-953): the cards' time, the timer's clock, its line and the
// fitters' chips are all redrawn from the same `now` in the same callback, so a card never reads a
// minute apart from the timer beside it. One interval for every screen, running while something does.
let now = Date.now();
let timer: number | undefined;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  if (timer === undefined) {
    now = Date.now();
    timer = window.setInterval(() => { now = Date.now(); listeners.forEach((l) => l()); }, 1000);
  }
  return () => {
    listeners.delete(listener);
    if (!listeners.size) { window.clearInterval(timer); timer = undefined; }
  };
}
const read = () => now;
const still = () => () => {};

// The shared `now`, ticking every second while `live` (a job runs); otherwise the last instant read.
export function useNow(live: boolean) {
  return useSyncExternalStore(live ? subscribe : still, read);
}

// The same instant outside a render — a tap's change is dated on the clock the screen is drawn from,
// so the time on screen neither jumps nor steps back at the tap.
export function instant() {
  if (timer === undefined) now = Date.now();
  return now;
}
